import { FormField } from 'src/components/molecules/FormField'

import { FormFieldTypes } from 'src/types/form'

import { businessTypeOptions } from '../../helper'

export const Business = () => {
  return (
    <FormField
      id='BusinessType'
      label='Business type'
      options={businessTypeOptions}
      type={FormFieldTypes.select}
    />
  )
}
